import {ConstantProperty} from "../../_models/constant-property";
import {ModelID} from "../../_typing/generic-types";
import {Field, Query, RuleSet, isRule, isRuleSet} from "../../_typing/query-builder";

const DIRECT_CONSTANT_PROPERTY_FIELD = /^\[constant_property@([^\]]+)\]$/;

export function getDirectConstantPropertyId(field: string): ModelID | null {
    return field?.match(DIRECT_CONSTANT_PROPERTY_FIELD)?.[1] || null;
}

export function getDirectConstantPropertyIds(query: RuleSet): ModelID[] {
    const propertyIds = new Set<ModelID>();

    const addQueryPropertyIds = (item: Query): void => {
        if (isRule(item)) {
            const propertyId = getDirectConstantPropertyId(item.field);
            if (propertyId) {
                propertyIds.add(propertyId);
            }
        } else if (isRuleSet(item)) {
            item.rules.forEach(addQueryPropertyIds);
        }
    };

    query?.rules?.forEach(addQueryPropertyIds);
    return Array.from(propertyIds);
}

export function fieldFromConstantProperty(constantProperty: ConstantProperty, name?: string): Field | null {
    if (constantProperty.attributes.data_type === 'file') {
        return null;
    }

    let type: string = constantProperty.attributes.data_type;
    let options;

    if (type === 'float') {
        type = 'number';
    }

    if (constantProperty.attributes.is_drop_down_list) {
        type = 'dropdown';
        options = (constantProperty.attributes.json || []).map(option => ({
            name: option,
            value: option
        }));
    }

    return {
        name: name || constantProperty.attributes.name,
        type,
        value: constantProperty.id,
        ...(type === 'dropdown' && {options})
    };
}
